import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const actionMenuDefaultVariants = {}
const actionMenuCompoundVariants = []

const actionMenuSlotNames = [
  [
    "surface",
    "ActionMenu__surface"
  ],
  [
    "list",
    "ActionMenu__list"
  ],
  [
    "item",
    "ActionMenu__item"
  ],
  [
    "icon",
    "ActionMenu__icon"
  ],
  [
    "label",
    "ActionMenu__label"
  ],
  [
    "dividerWrap",
    "ActionMenu__dividerWrap"
  ],
  [
    "renderRow",
    "ActionMenu__renderRow"
  ]
]
const actionMenuSlotFns = /* @__PURE__ */ actionMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, actionMenuDefaultVariants, getSlotCompoundVariant(actionMenuCompoundVariants, slotName))])

const actionMenuFn = memo((props = {}) => {
  return Object.fromEntries(actionMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const actionMenuVariantKeys = [
  "tone"
]
const getVariantProps = (variants) => ({ ...actionMenuDefaultVariants, ...compact(variants) })

export const actionMenu = /* @__PURE__ */ Object.assign(actionMenuFn, {
  __recipe__: false,
  __name__: 'actionMenu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: actionMenuVariantKeys,
  variantMap: {
  "tone": [
    "critical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, actionMenuVariantKeys)
  },
  getVariantProps
})